import { Box, Grid, GridColumn } from "@modernatx-internal/component-library";
import React from "react";

import { ContentComponentProps, FeatureCardContent } from "@/content-V2/types";

export const FeatureCard: React.FC<ContentComponentProps<FeatureCardContent>> = ({
  children,
  direction = "start",
  image
}) => {
  const isStart = direction === "start";

  const contentMedia = (
    <Box
      sx={{
        aspectRatio: ["17 / 13", "none"],
        backgroundColor: "surface-neutral-tertiary",
        backgroundRepeat: "no-repeat",
        backgroundSize: "cover",
        borderEndEndRadius: isStart ? null : "radius-3",
        borderEndStartRadius: isStart ? ["none", null, "radius-3"] : ["radius-3", "radius-3", null],
        borderStartEndRadius: isStart ? ["radius-3", null, 0] : ["none", null, "radius-3"],
        borderStartStartRadius: isStart ? "radius-3" : null,
        height: ["auto", 111, 114],
        marginInlineEnd: isStart ? [1, 1, 0] : 1,
        marginInlineStart: isStart ? 1 : [1, 1, 0],
        mb: isStart ? [0, 0, 1] : 1,
        mt: isStart ? 1 : [0, 0, 1],
        overflow: "hidden"
      }}
    >
      {image}
    </Box>
  );

  const contentText = (
    <Box
      sx={{
        display: "flex",
        flex: 1,
        flexDirection: "column",
        justifyContent: "center",
        paddingInlineEnd: [8, null, 8],
        paddingInlineStart: [8, null, 0],
        py: [6, null, 12]
      }}
    >
      {children}
    </Box>
  );

  return (
    <Grid>
      <GridColumn>
        <Box
          sx={{
            backgroundColor: "surface-neutral",
            borderColor: "stroke-neutral",
            borderRadius: "radius-3",
            borderStyle: "solid",
            borderWidth: "1px",
            boxShadow: "shadow-300",
            minHeight: [null, null, 86]
          }}
        >
          <Grid>
            <GridColumn size={[12, 12, 6]}>{isStart ? contentMedia : contentText}</GridColumn>
            <GridColumn size={[12, 12, 6]}>{isStart ? contentText : contentMedia}</GridColumn>
          </Grid>
        </Box>
      </GridColumn>
    </Grid>
  );
};
